export default {"src":"/_next/static/media/icon_recurring_trophies_timer.72e29aad.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};